import useNamespacedLocalStorage from 'app/hooks/useNamespacedLocalStorage';
import { useEffect, useMemo } from 'react';
import { Location, useLocation } from 'react-router-dom';

const HISTORY_LENGTH = 5;

export default function useHistory() {
  const [history] = useNamespacedLocalStorage<Location[]>('ostroHistory', []);

  const entries = useMemo(() => {
    return history.map((entry) => entry.pathname);
  }, [history]);

  const [location] = useMemo(() => history.slice(-1), [history]);
  const [prevLocation] = useMemo(() => history.slice(-2, -1), [history]);

  return {
    entries,
    location,
    prevLocation,
    history,
  };
}

export function useHistoryWriter() {
  const [history, setHistory, removeHistory] = useNamespacedLocalStorage<Location[]>('ostroHistory', []);

  const location = useLocation();

  useEffect(() => {
    const [last] = history.slice(-1);
    const [prev] = history.slice(-2, -1);

    if (last?.pathname !== location.pathname) {
      if (prev?.pathname === location.pathname) {
        // User navigated back, remove the last entry
        const h = history.slice(0, -1);
        setHistory(h);
      } else {
        // Add new location to history
        const h = [...history, location].slice(-HISTORY_LENGTH);
        setHistory(h);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return { history, removeHistory };
}
